/** Tooltip copy for Generate Questions dialog labels — presentation only. */
export const GENERATE_QUESTION_FIELD_HELP = {
  noOfQuestions: 'Total number of questions Yaki will generate for this assessment.',
  gradeLevel: 'Target grade or education level — guides question complexity and vocabulary.',
  assessmentLevel: 'One or more difficulty tiers (for example Easy, Medium, Hard) to shape question rigor.',
  language: 'Language used to generate and categorize exam questions.',
  examType: 'Format of the exam content — for example text-based questions or practical items.',
};
